export default __webpack_public_path__ + "/dist/images/6314847.png";